
import Amplify from 'aws-amplify';
import { Auth } from 'aws-amplify';



Amplify.configure({
    Auth: {
    // REQUIRED - Amazon Cognito Identity Pool ID
        // identityPoolId: 'us-east-1:16c7cd5e-52d1-442d-af74-235153fea56d',
    // REQUIRED - Amazon Cognito Region
        region: process.env.REACT_APP_CG_REGION,
    // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: process.env.REACT_APP_CG_USERPOOLID,
    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        userPoolWebClientId: process.env.REACT_APP_CG_WEBCLIENTID,
    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
        // mandatorySignIn: true,
    // // OPTIONAL - Configuration for cookie storage
    //     cookieStorage: {
    //     // REQUIRED - Cookie domain (only required if cookieStorage is provided)
    //         domain: '.yourdomain.com',
    //     // OPTIONAL - Cookie path
    //         path: '/',
    //     // OPTIONAL - Cookie expiration in days
    //         expires: 365,
    //     // OPTIONAL - Cookie secure flag
    //         secure: true
    //     }
    }
});
let userStatusObj={
    username: "",
    password: "",
    instruction: "Please login to continue",
    usernameError: false,
    passwordError: false,
    nameError: false,
    user: null,
    status:404
 }
export default async function AwsAuthSignIn(userObj){
    let user = JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.payload;
    userObj.username = user.email;
    if(userObj.username !== '' && userObj.password !== '')
    {
       await Auth.signIn(userObj.username, userObj.password)
        .then(user => {
            userStatusObj.username=userObj.username;
            userStatusObj.password=userObj.password;
            userStatusObj.instruction='Successfully Authenticate';
            userStatusObj.usernameError=false;
            userStatusObj.passwordError=false;
            userStatusObj.user = user;
            userStatusObj.status = 200;
        })
        .catch(err => {
            switch(err.code){
                case 'UserNotFoundException':
                        userStatusObj.instruction = err.message;
                        userStatusObj.usernameError = true;
                break;
                case 'NotAuthorizedException':
                default:
                        userStatusObj.instruction = 'Invalid username or password.';
                        userStatusObj.usernameError = true;
                        userStatusObj.passwordError=true;
            }
        });
    }
    return userStatusObj;
}


// WEBPACK FOOTER //
// ./src/components/AwsService/aws-auth-signin.js